(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/api-errors/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tur/api-errors/assets/prescript.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.apierrors = svs.tur.apierrors || {};
svs.tur.apierrors.apiCalls = svs.tur.apierrors.apiCalls || {};

 })(window);